import tools from '../../../assets/javascript/tools.js'
export default {
	columns: {
		title: {
			label: '订单商品',
			visible: true,
			minWidth: '200',
			align: 'left',
		},
		customerName: {
			label: '客户信息',
			visible: true,
			minWidth: '160',
			align: 'left',
		},
    ownDiscountDatas: {
			label: '持有折扣卡',
			visible: true,
			minWidth: '160',
			align: 'left',
		},
		staffNames: {
			label: '店员',
			visible: true,
			width: '100',
			align: 'left',
		},

		itemNum: {
			label: '物品数量',
			visible: true,
			width: '80',
			align: 'left',
		},
		orderSourceCn: {
			label: '订单来源',
			visible: true,
			width: '100',
			align: 'left',
		},
		orderStatusCn: {
			label: '订单状态',
			visible: true,
			width: '100',
			align: 'left',
		},
		payWayCn: {
			label: '支付方式',
			visible: true,
			width: '150',
			align: 'left',
		},
		discountAmount: {
			label: '折扣优惠',
			visible: true,
			width: '100',
			align: 'left',
		},
		orderAmount: {
			label: '应付金额',
			visible: true,
			width: '100',
			align: 'left',
		},
		realPayAmount: {
			label: '实际金额',
			visible: true,
			width: '100',
			align: 'left',
		},
		orderTime: {
			label: '下单时间',
			visible: true,
			formatDay: true,
			width: '160',
			align: 'left',
		},
		payTime: {
			label: '支付时间',
			visible: true,
			formatDay: true,
			width: '160',
			align: 'left',
		},
	},
}
